const DEFAULT_FRACTION_DIGITS = 3;

/**
 * Rounds a value up to the given number of decimal places (3 by default),
 * matching the token-balance display precision used across LeMans grids.
 */
export function roundToThreeDecimals(value: number, fractionDigits: number = DEFAULT_FRACTION_DIGITS): number {
  const roundingFactor = Math.pow(10, fractionDigits);
  return Math.ceil(value * roundingFactor) / roundingFactor;
}
